class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector(':scope > summary');
      this.close = el.querySelector('.js-details-close');
      this.content = el.querySelector(':scope > *:not(summary)');
      this.wrapper = el.closest('.jsAccordionWrapper');
  
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
  
      this.summary.addEventListener('click', (e) => this.onClick(e));
  
      if (this.close) {
        this.close.closest('details') == this.el && this.close.addEventListener('click', (e) => this.onClick(e));
      }
  
      this.el.classList.add('accordion-initialized');
    }
  
    onClick(e) {
      e.preventDefault();
      e.stopPropagation();
  
      this.el.style.overflow = 'hidden';
  
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }
  
    shrink() {
      this.isClosing = true;
  
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;
  
      if (this.animation) {
        this.animation.cancel();
      }
  
      this.el.classList.add('is-closing');
      if (this.el.closest("sticky-component")) {
        this.el.closest("sticky-component").classList.add("layout-mobile");
        document.body.classList.remove("sticky-opened");
      }
  
      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
  
      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }
  
    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
  
      if (this.el.closest("sticky-component")) {
        this.el.closest("sticky-component").classList.remove("layout-mobile");
        document.body.classList.add("sticky-opened");
      }
  
      window.requestAnimationFrame(() => this.expand());
    }
  
    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
  
      if (this.animation) {
        this.animation.cancel();
      }
  
      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }
  
    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
  
      this.el.classList.remove('is-closing');
  
      this.wrapper?.classList.toggle('accordion-showing', open);
      if (open && this.el.closest("sticky-component") !== null) {
  
        document.documentElement.style.setProperty('--sticky-height', `${this.el.closest("sticky-component").offsetHeight + 12}px`)
      }
    }
  }
  
  
  const selectors = {
    activeList: document.querySelectorAll('details[open]:not(.noJS)')
  };
  
  document.addEventListener('click', e => {
    if (!selectors.activeList.length) return;
  
    !e.target.closest('details') && selectors.activeList.forEach(j => {
      if (j.closest('.accordion-initialized')) return;
  
      j.open = false;
    })
  })
  
  window.customElements.define('accordion-component', class extends HTMLElement {
    constructor() {
      super();
  
      if (this.hasAttribute('data-open-screen') || this.hasAttribute('data-close-screen')) {
        const { debounceTime } = theme;
        const debounce = debounceTime(e => this.changeState(e), 300);
        window.addEventListener('resize', debounce.bind(this));
      }
    }
  
    connectedCallback() {
      this.Accordion = new Accordion(this.querySelector('details'));
      this.changeState();
    }
  
    changeState() {
      this.hasAttribute('data-open-screen') && window.matchMedia(this.getAttribute('data-open-screen')).matches && (this.querySelector('details').open = true);
      this.hasAttribute('data-close-screen') && window.matchMedia(this.getAttribute('data-close-screen')).matches && (this.querySelector('details').open = false);
    }
  })